import React from 'react';
import { CheckCircle2, MapPin, Zap, Calculator } from 'lucide-react';
import { whyUs } from '../data/mockData';

const iconMap = {
  CheckCircle2: CheckCircle2,
  MapPin: MapPin,
  Zap: Zap,
  Calculator: Calculator
};

export const WhyUs = () => {
  return (
    <section id="why-us" className="py-24 bg-bg-page">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="heading-2 mb-6">
            PROČ SI VYBRAT PRÁVĚ NÁS?
          </h2>
          <p className="body-medium text-text-secondary max-w-3xl mx-auto">
            Důvěřujte odborníkům – přestavíme, opravíme, postavíme
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {whyUs.map((item) => {
            const IconComponent = iconMap[item.icon];
            return (
              <div 
                key={item.id}
                className="text-center p-8 bg-white border border-border-light rounded-lg transition-all duration-300 hover:border-brand-primary hover:shadow-lg hover:-translate-y-2"
              >
                <div className="inline-flex items-center justify-center w-20 h-20 bg-red-50 rounded-full mb-6 border-2 border-red-200">
                  <IconComponent style={{ color: '#dc143c' }} size={36} strokeWidth={2.5} />
                </div>
                <h3 className="heading-6 text-brand-primary mb-3">
                  {item.title}
                </h3>
                <p className="body-small text-text-secondary">
                  {item.description}
                </p>
              </div>
            );
          })}
        </div>

        <div className="mt-16 text-center">
          <div className="inline-block bg-brand-primary/10 border border-brand-primary rounded-lg px-8 py-6">
            <p className="heading-5 text-brand-primary">
              Ozvěte se nám ještě dnes!
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
